import React, { useState } from "react";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";


const MNPG008 = (props: TMainPageLayoutV2) => {
    console.log("MNPG008.rendered", props);

    const [languageVersion] = useState(outerNameDescriptionLanguageVersion(props.template?.languageVersions));

    const [contactUs] = useState(props.templates?.find((item) => item.parentId === props.template?.id));
    const [address] = useState(metaDataLanguageVersion("address", contactUs?.languageVersions));
    const [phone] = useState(metaDataLanguageVersion("phone", contactUs?.languageVersions));
    const [email] = useState(metaDataLanguageVersion("email", contactUs?.languageVersions));

    if ( !props.template ) return null;

    return (
        <div className="col-lg-4 col-sm-6">
            <div
                className="single-footer-widget"
                data-aos="fade-in"
                data-aos-duration="1000"
                data-aos-delay="400"
            >
                <h3>{languageVersion?.name}</h3>

                <ul className="get-in-touch">
                    <li className="pt-2">
                        <i className="fa-solid fa-location-dot"></i> {address}
                    </li>
                    <li className="pt-2">
                        <i className="fa-solid fa-headset"></i>
                        <a href={`tel:${phone?.trim()?.replace(/[^0-9]/g, "")}`}>{phone}</a>
                    </li>
                    <li>
                        <i className="fa-solid fa-envelope"></i>
                        <a href={`mailto:${email}`}>{email}</a>
                    </li>
                </ul>
            </div>
        </div>
    )
}

const Component = React.memo(MNPG008, (prevProps: TMainPageLayoutV2, nextProps: TMainPageLayoutV2) => {
    console.log("MNPG008.memo", { prevProps, nextProps });
    return true;
});

export default Component;
